module.exports = __webpack_public_path__ + "img/request_top.32244a78.jpg";